import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// Static Components (Load Immediately)
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import ScrollToTop from "./components/ScrollToTop"; // Recommended helper

// Lazy Load Pages (Loaded only when the route is visited)
const Index = lazy(() => import("./components/Home"));
const About = lazy(() => import("./components/About/About"));
const Blogs = lazy(() => import("./components/Blogs/Blogs"));
const ContactUs = lazy(() => import("./components/ContactUs/ContactUs"));
const Gallery = lazy(() => import("./components/Gallery/Gallery"));
const Pricing = lazy(() => import("./components/pricing/Pricing"));
const Reviews = lazy(() => import("./components/review/Reviews"));
const Career = lazy(() => import("./components/career/Career"));
const AppointmentForm = lazy(() => import("./components/AppointmentForm/AppointmentForm"));
const LegacyPage = lazy(() => import("./components/LegacyPage"));
const NotFound = lazy(() => import("./components/NotFound/NotFound"));

// Lazy Load Treatments
const TeethCleaning = lazy(() => import("./components/submenu/generaldentistry/TeethCleaning"));
const CrownsBridges = lazy(() => import("./components/submenu/generaldentistry/CrownsBridges"));
const PainFreeRootCanal = lazy(() => import("./components/submenu/generaldentistry/PainFreeRootCanal"));
const Dentures = lazy(() => import("./components/submenu/generaldentistry/Dentures"));
const DentalRestorations = lazy(() => import("./components/submenu/generaldentistry/DentalRestorations"));
const Mouthguards = lazy(() => import("./components/submenu/generaldentistry/Mouthguards"));

const SmileMakeover = lazy(() => import("./components/submenu/COSMETICPROCEDURE/SmileMakeover"));
const TeethWhitening = lazy(() => import("./components/submenu/COSMETICPROCEDURE/TeethWhitening"));
const GumDepigmentation = lazy(() => import("./components/submenu/COSMETICPROCEDURE/GumDepigmentation"));
const FullMouthRehabilitation = lazy(() => import("./components/submenu/COSMETICPROCEDURE/FullMouthRehabilitation"));
const CompositeVeneers = lazy(() => import("./components/submenu/COSMETICPROCEDURE/CompositeVeneers"));

const WisdomToothRemoval = lazy(() => import("./components/submenu/SURGICAL PROCEDURE/WisdomToothRemoval"));
const FullMouthImplants = lazy(() => import("./components/submenu/SURGICAL PROCEDURE/FullMouthImplants"));
const BoneGrafting = lazy(() => import("./components/submenu/SURGICAL PROCEDURE/BoneGrafting"));
const ImplantsWithoutBoneGrafting = lazy(() => import("./components/submenu/SURGICAL PROCEDURE/ImplantsWithoutBoneGrafting"));

const InvisibleBraces = lazy(() => import("./components/submenu/ORTHODONTIC PROCEDURE/InvisibleBraces"));
const MetalBraces = lazy(() => import("./components/submenu/ORTHODONTIC PROCEDURE/MetalBraces"));

// Simple Loader Component
const PageLoader = () => (
  <div style={{ height: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div className="spinner-border text-primary" role="status"></div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      {/* Ensures page starts at top when navigating */}
      <ScrollToTop /> 
      
      <Header />

      {/* Suspense handles the loading state of lazy components */}
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Main Routes */}
          <Route path="/" element={<Index />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/appointment" element={<AppointmentForm />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/careers" element={<Career />} />

          {/* General Dentistry */}
          <Route path="/treatments/teeth-cleaning" element={<TeethCleaning />} />
          <Route path="/treatments/crowns-bridges" element={<CrownsBridges />} />
          <Route path="/treatments/pain-free-root-canal" element={<PainFreeRootCanal />} />
          <Route path="/treatments/dentures" element={<Dentures />} />
          <Route path="/treatments/dental-restorations" element={<DentalRestorations />} />
          <Route path="/treatments/mouthguards" element={<Mouthguards />} />

          {/* Cosmetic */}
          <Route path="/treatments/smile-makeover" element={<SmileMakeover />} />
          <Route path="/treatments/teeth-whitening" element={<TeethWhitening />} />
          <Route path="/treatments/gum-depigmentation" element={<GumDepigmentation />} />
          <Route path="/treatments/full-mouth-rehabilitation" element={<FullMouthRehabilitation />} />
          <Route path="/treatments/composite-veneers" element={<CompositeVeneers />} />

          {/* Surgical */}
          <Route path="/treatments/wisdom-tooth-removal" element={<WisdomToothRemoval />} />
          <Route path="/treatments/full-mouth-implants" element={<FullMouthImplants />} />
          <Route path="/treatments/bone-grafting" element={<BoneGrafting />} />
          <Route path="/treatments/implants-without-bone-grafting" element={<ImplantsWithoutBoneGrafting />} />

          {/* Orthodontics */}
          <Route path="/treatments/invisible-braces" element={<InvisibleBraces />} />
          <Route path="/treatments/metal-braces" element={<MetalBraces />} />

          {/* Fallback */}
          <Route path="/legacy" element={<LegacyPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>

      <Footer />
      <FloatingButtons />
    </BrowserRouter>
  );
}

export default App;